import { render, staticRenderFns } from "./SwitchWithText.vue?vue&type=template&id=04704838&scoped=true&"
import script from "./SwitchWithText.vue?vue&type=script&lang=js&"
export * from "./SwitchWithText.vue?vue&type=script&lang=js&"
import style0 from "./SwitchWithText.vue?vue&type=style&index=0&id=04704838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04704838",
  null
  
)

export default component.exports